const LogoR = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 569 635"
		fill="none"
		{...props}
	>
		<path
			fill="#03488E"
			d="M39.943.389H352.09c234.621 6.776 298.516 366.956 91.156 457.594-11.416 6.777-20.276 1.525-22.832 0-31.691-19.314-52.308-36.933-75.14-70.308-4.6-8.979 3.749-12.537 6.816-13.553 126.937-45.573 112.625-251.584-38.678-260.563H117.468c-52.308-2.541-86.556-30.495-95.757-99.617C21.541 5.641 26.653.558 39.943.389Z"
		/>
		<path
			fill="#03488E"
			d="M43.072 265.125c234.173-2.14 292.216 246.492 481.689 264.099 13.343 0 22.35 6.582 22.35 17.607-6.671 79.147-86.897 114.36-173.962 65.983C226.04 520.338 190.347 401.535 78.765 383.928c-35.693-4.443-51.705-1.645-55.708-24.188l-2.168-70.427c0-15.467 4.503-24.188 22.35-24.188h-.167Z"
		/>
		<path
			fill="#03488E"
			d="M91.39 622.17c50.326 0 91.123-40.798 91.123-91.123 0-50.326-40.797-91.123-91.123-91.123-50.326 0-91.123 40.797-91.123 91.123 0 50.325 40.797 91.123 91.123 91.123Z"
		/>
		<path
			fill="#00BCDE"
			d="M13.15 531.047c0-47.978 34.62-87.326 78.58-90.778-2.094 0-4.348-.345-6.442-.345-47.019 0-85.02 40.729-85.02 91.123 0 50.393 38.001 91.123 85.02 91.123s4.348-.001 6.441-.346c-43.96-3.624-78.58-42.8-78.58-90.777ZM541.695 364.88C614.275 225.64 535.221 5.627 352.238.389H39.942c-13.29.338-18.401 5.407-18.23 13.518 9.2 68.944 43.445 96.995 95.75 99.361H315.608c168.841-11.66 269.362 112.372 225.917 251.443l.17.169ZM21.877 292.657l2.203 70.586c4.238 22.594 20.342 19.79 56.617 24.243 113.402 17.647 149.507 136.72 299.184 229.405 13.052 7.092 25.935 12.369 38.479 15.997-68.652-58.052-35.597-161.127-113.233-238.805l-1.017-2.804C236.137 327.785 160.032 263.956 42.223 265.11c-18.138 0-20.516 12.044-20.516 27.547h.17Z"
		/>
	</svg>
);
export default LogoR;
